window.Page = {

    images : document.querySelectorAll('.photography-gallery-image'),

    // Let's launch this thing
    liftoff : () => {
        Page.swapImages()
    },

    // My new function block
    swapImages : () => {

        Page.images.forEach(image => {

            let intersectionObserver = new IntersectionObserver((entries,observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.src = entry.target.dataset.src
                        observer.unobserve(entry.target)
                    }
              });
            });
        
            intersectionObserver.observe(image);

        })

    }

};

Page.liftoff()